import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { Modal, Button, Form } from 'semantic-ui-react';
import { v4 as uuid } from 'uuid';
import { useStore } from '../../app/stores/store';

interface Props {
  startDate: string;
  endDate: string;
}
function PivotSmallModal({ startDate, endDate }: Props) {
  const { PivotStore } = useStore();
  const [pivotName, setPivotName] = useState('');
  return (
    <Modal
      onClose={() => PivotStore.setOpenPivotReportModal(false)}
      onOpen={() => PivotStore.setOpenPivotReportModal(true)}
      open={PivotStore.pivotReportModal}
    >
      <Modal.Header>Dynamic Pivot Report</Modal.Header>

      <Modal.Content style={{ color: 'black' }}>
        <Form style={{ marginTop: '0px' }}>
          <Form.Group widths="equal">
            <Form.Input
              label="Pivot Table Name"
              placeholder="Please enter a name for pivot report"
              onChange={(e: any) => setPivotName(e.target.value)}
            />
          </Form.Group>
        </Form>

        {/* Please Choose a name to save */}
      </Modal.Content>

      <Modal.Actions>
        <Button.Group>
          <Button onClick={() => PivotStore.setOpenPivotReportModal(false)}>
            Cancel
          </Button>
          <Button.Or />
          <Button
            positive
            disabled={pivotName.length > 0 ? false : true}
            onClick={() => {
              PivotStore.saveAsPivotData(pivotName, startDate, endDate, uuid());
              PivotStore.setOpenPivotReportModal(false);
            }}
          >
            Save
          </Button>
        </Button.Group>
      </Modal.Actions>
    </Modal>
  );
}

export default observer(PivotSmallModal);
